module.exports = __webpack_public_path__ + "img/wen1.e4b40a2d.png";